import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import '../../../../../store/js/modules/statspro/stats-leaders/reducer/types';
import { useCompetitionNavigationOptions } from '../../../../../../../common/react/hooks/use-competition-navigation-options';
import { statsLeadersNavSelector } from '../../../../../store/js/modules/statspro/stats-leaders/selectors/nav-selector';
import { UPDATE_NAV_ITEM } from '../../../../../store/js/modules/statspro/stats-leaders/actions';
import { CategoryNavItem } from './CategoryNavItem';
import { SeasonNavItem } from './SeasonNavItem';
import { RoundNavItem } from './RoundNavItem';

export const StatsLeadersNav = ( { children } ) => {
    const dispatch = useDispatch();
    const nav = useSelector( statsLeadersNavSelector );

    const { seasons, rounds } = useCompetitionNavigationOptions( {
        competition: nav.competition,
        season: nav.season,
        round: nav.round
    } );
    
    const updateNavSelection = ( navItem, value ) => {
        dispatch( UPDATE_NAV_ITEM.request( { navItem, value } ) );
    };

    return (
        <div className="stats-leaders-nav">
            <div className="stats-leaders-nav__item-wrapper">
                <CategoryNavItem
                    updateNavSelection={ updateNavSelection }
                />
            </div>
            <div className="stats-leaders-nav__item-wrapper">
                <SeasonNavItem
                    updateNavSelection={ updateNavSelection }
                    seasons={ seasons ?? []}
                />
            </div>
            <div className="stats-leaders-nav__item-wrapper">
                <RoundNavItem
                    updateNavSelection={ updateNavSelection }
                    rounds={ rounds ?? [] }
                />
            </div>
            <div className="stats-leaders-nav__filter-button-wrapper">
                { children }
            </div>
        </div>
    );
};

StatsLeadersNav.propTypes = {
    children: PropTypes.any
};
